import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  external?: boolean;
}
export function CTAButton({
  children,
  className = '',
  href = '#offer',
  external = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (external && typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart', {
        content_name: 'Adiós Pañal en 3 Días',
        content_type: 'product',
        value: 6.36,
        currency: 'USD'
      });
    }
  };
  return <motion.a href={href} onClick={handleClick} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`inline-block bg-coral hover:bg-coral-dark text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-full shadow-lg hover:shadow-xl transition-colors duration-300 text-center ${className}`} data-id="element-14">
      {children}
    </motion.a>;
}